var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 11.2C14.0135 11.2 12.4001 12.2799 12.4001 13.5999C12.4001 14.9199 14.0135 15.9999 16.0001 15.9999C17.9868 15.9999 19.6001 17.08 19.6001 18.4C19.6001 19.72 17.9868 20.7999 16.0001 20.7999",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.2V20.7999",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.2C17.3333 11.2 18.4933 11.68 19.12 12.4L16 11.2Z",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.2V10",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.8V22.0001",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 20.8C14.6668 20.8 13.5068 20.32 12.8801 19.6L16.0001 20.8Z",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16C28 17.5733 27.6933 19.1333 27.08 20.5867C26.48 22.04 25.5867 23.36 24.48 24.48C23.36 25.6 22.04 26.48 20.5867 27.08C19.1333 27.6933 17.5733 28 16 28C14.4267 28 12.8667 27.6933 11.4133 27.08C9.96 26.4667 8.64 25.5867 7.52 24.48C6.4 23.36 5.52 22.04 4.92 20.5867C4.30666 19.1333 4 17.5733 4 16C4 12.8133 5.26667 9.76 7.52 7.52C9.76 5.26667 12.8133 4 16 4C19.1867 4 22.24 5.26667 24.48 7.52C26.7333 9.76 28 12.8133 28 16Z",
    stroke: "#416FF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.5ec7adc3f480a0b8ea4e764d2d443ba8.svg";
export { ForwardRef as ReactComponent };